
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_1nw5k_13",
  "result-state": "awsui_result-state_11huc_1nw5k_27",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_1nw5k_1",
  "root": "awsui_root_11huc_1nw5k_67",
  "with-result-button": "awsui_with-result-button_11huc_1nw5k_99",
  "result-text": "awsui_result-text_11huc_1nw5k_103",
  "result-container-error": "awsui_result-container-error_11huc_1nw5k_107",
  "result-container-success": "awsui_result-container-success_11huc_1nw5k_107",
  "result-button": "awsui_result-button_11huc_1nw5k_111",
  "word-wrap": "awsui_word-wrap_11huc_1nw5k_117",
  "label-flash": "awsui_label-flash_11huc_1nw5k_122",
  "label-key-value": "awsui_label-key-value_11huc_1nw5k_126",
  "flash": "awsui_flash_11huc_1nw5k_134",
  "progress-container": "awsui_progress-container_11huc_1nw5k_138",
  "percentage-container": "awsui_percentage-container_11huc_1nw5k_145",
  "percentage": "awsui_percentage_11huc_1nw5k_145",
  "percentage-flash": "awsui_percentage-flash_11huc_1nw5k_166",
  "complete": "awsui_complete_11huc_1nw5k_206",
  "progress-flash": "awsui_progress-flash_11huc_1nw5k_219",
  "additional-info": "awsui_additional-info_11huc_1nw5k_232"
};
  